import { TimeoutError } from 'rxjs';
import { defaultError } from 'src/constants/defaults';

interface HandleParams {
  request: Promise<any>;
  stringifyError?: boolean;
  defaultErrorMessage?: string;
}
export class HttpUtils {
  // Move this to authHttpServ once there's time to.
  static async handle<TRes = any>({
    request,
    stringifyError = false,
    defaultErrorMessage = defaultError,
  }: HandleParams): Promise<TRes | undefined> {
    try {
      const resp: Response = await request;
      if (!resp || resp.status === 204) return;

      return resp as TRes;
    } catch (error) {
      console.log(error);

      if (!stringifyError) {
        throw error;
      }

      throw HttpUtils.stringifyError(error, defaultErrorMessage);
    }
  }

  static stringifyError(error: any, defaultErrorMessage: string = defaultError) {
    let finalTextError = '';
    if (typeof error === 'string') {
      finalTextError = error;
    } else if (typeof error === 'object') {
      // if (error?.error?.text) {
      // 	return error.error.text as string;
      // }

      try {
        const errAsJson = error.json();
        finalTextError = errAsJson.Message || errAsJson.error || errAsJson.message;
      } catch (_) {}

      finalTextError = finalTextError || error._body || error.statusText;
    }
    return finalTextError || defaultErrorMessage;
  }

  static toParamsString(rawParams: { [key: string]: any } = {}) {
    const params = new URLSearchParams();
    Object.keys(rawParams)
      .filter((k) => rawParams[k] !== undefined && rawParams[k] !== null)
      .forEach((k) => params.set(k, HttpUtils.castOrDefault(rawParams[k])));
    return params.toString();
  }

  static isBadRequest(error: any) {
    return error && (error.status === 400 || error.status === 404);
  }

  static isInvalidGrant(error: any) {
    if (!error || error.status !== 400) return false;

    const body = error.error;
    if (!body) return false;
    if (typeof body === 'string') return body.indexOf('invalid_grant') !== -1;

    return body.error === 'invalid_grant';
  }

  static isNotAuthenticatedError(error: any) {
    return error && error.status === 401;
  }

  static isForbidden(error: any) {
    return error && error.status === 403;
  }

  static isServerError(error: any) {
    return error === defaultError;
  }

  static isTimeout(error: any) {
    return error && (error instanceof TimeoutError || error.status === 0 || error.status >= 500);
  }

  private static castOrDefault<T extends Object>(param: T): string {
    let res = param.toString();

    if (param instanceof Date) res = param.toISOString();

    return res;
  }
}
